export default __webpack_public_path__ + "static/media/disconnectShopify2.9cca1fcd.svg";